import React from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Box } from '../../../../third-party-components/material-ui';

import { isMobile } from 'react-device-detect';

const yesTexts = {
    en: 'Yes',
    fr: 'Oui',
    es: 'Sí'
};

const noTexts = {
    en: 'No',
    fr: 'Non',
    es: 'No'
};

const TaskDialog = ({includeNext = true, visible, onYes, onNo, children, header, lang}) => (
    <div>
            {visible &&
            <Dialog title=" " closeIcon={true} onClose={onNo} className='task-dialog'>
                <Box className="task-dialog-container">
                    {!!header && (
                        <Box className="task-dialog-header">
                            <Box>
                                {header}
                            </Box>
                        </Box>
                    )}
                    <Box className="task-dialog-body">
                        <Box>
                            {children}
                        </Box>
                    </Box>
                </Box>
                <DialogActionsBar className="dialog-actions-bar">
                    <button className="k-button" onClick={onYes} style={{ height: 80, fontSize: 17 }}>{yesTexts[lang]}</button>
                    {includeNext ? <button className="k-button" onClick={onNo} style={{ height: 80, fontSize: 17 }}>{noTexts[lang]}</button> : null}
                </DialogActionsBar>
            </Dialog>}
        </div>
)

export default TaskDialog;